import { Button } from 'antd'
import { globalConfirm, globalToaster } from 'components/elements/global'
import { useDeleteNoteMutationMutation } from 'features/leads'
import { TUserActivityNote } from 'features/leads/types'
import useAuth from 'hooks/useAuth'
import { FC } from 'react'

const ActivityNoteActions: FC<{
 note?: TUserActivityNote
 onEdit?: (note: TUserActivityNote) => void
 onDeleted?: () => void
 isTransferred?: boolean
}> = ({ note, onEdit, onDeleted, isTransferred }) => {
 const [deleteNote] = useDeleteNoteMutationMutation()
 const { user } = useAuth()
 // Edit/Delete only show when the lead is a transfer lead AND the note belongs to the current user
 const editable =
  isTransferred === true &&
  note?.create_by_user_id != null &&
  String(note.create_by_user_id) === String(user?.id)
 // Timeline ("ALL") rows carry activity_id as the real note id — id there is a
 // synthetic feed-row id. The standalone Notes tab has no activity_id, so id is used as-is.
 const noteId = note?.activity_id ?? note?.id

 const copyNote = async () => {
  // ALL-feed rows (TUserAllActivity) have no `content` field, only `description`
  const plainText = note?.content ?? note?.description ?? ''
  await navigator.clipboard.writeText(plainText)
  globalToaster({ type: 'success', content: 'Note copied' })
 }

 const confirmAndDeleteNote = () => {
  globalConfirm({
   title: 'Delete Note',
   content: 'Are you sure you want to delete this note?',
   okText: 'Delete',
   onOk: async () => {
    await deleteNote({ id: [noteId] }).unwrap()
    onDeleted?.()
   },
  })
 }

 return (
  <div className="d-flex justify-content-end">
   <Button
    size="small"
    shape="circle"
    onClick={copyNote}
    className="me-1"
    title="Copy note"
   >
    <i className="fas fa-copy" />
   </Button>
   {editable && (
    <Button
     size="small"
     shape="circle"
     onClick={() => onEdit?.({ ...note, id: noteId } as TUserActivityNote)}
     className="me-1"
     title="Edit note"
    >
     <i className="fas fa-edit" />
    </Button>
   )}
   {editable && (
    <Button
     size="small"
     shape="circle"
     danger
     onClick={confirmAndDeleteNote}
     title="Delete note"
    >
     <i className="fas fa-trash" />
    </Button>
   )}
  </div>
 )
}

export default ActivityNoteActions
